// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"143":"8c5b220b","222":"d6eb0fab","339":"c2363bfe","574":"96772824","736":"12ebf4ef"}[chunkId] + ".css";
};